// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__9Zrss","itemTitle":"ClientEmergencyInfo_itemTitle__24ute","itemText":"ClientEmergencyInfo_itemText__ZSZWM"};